import { generateRepositoryMethods, } from '../webapp/repository.types.js';
export const userRepositoryMethods = generateRepositoryMethods({
    deactivateMfa: {
        callMethod: 'POST',
        endpoint: '/user/deactivate-mfa',
    },
    setUserState: {
        callMethod: 'POST',
        endpoint: '/user/set-state',
    },
});
//# sourceMappingURL=user.methods.js.map